import { render, staticRenderFns } from "./memberData.vue?vue&type=template&id=b3260206&"
import script from "./memberData.vue?vue&type=script&lang=js&"
export * from "./memberData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports